const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

export const resolveImageUrl = (imagePath, fallback = null) => {
  if (!imagePath) return fallback;

  // ✅ Base64 image stored directly in Firestore
  if (imagePath.startsWith('data:image')) return imagePath;

  // ✅ Already a full URL (Firebase Storage or external)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;

  // ✅ Local /uploads path — prepend API base
  if (imagePath.startsWith('/uploads') || imagePath.startsWith('uploads')) {
    return `${API_BASE}/${imagePath.replace(/^\//, '')}`;
  }

  return fallback;
};

export const NEWS_PLACEHOLDER    = 'https://placehold.co/600x400/FFF7EF/7B2A3B?text=Kumbhar+Samaj+News';
export const PROFILE_PLACEHOLDER = 'https://placehold.co/400x400/FFF7EF/7B2A3B?text=Profile';